// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMModel } from '../components/form/model/lm-model';
import { LMModelField } from '../components/form/model/lm-model-field';
import { AppConstants } from './app.constants';
import { LMFieldUtilService } from '../services/utils/lm-field-util.service';
import { Subject } from 'rxjs';

@Injectable()
export class LMConditionUtilService {
  private _evaluateConditions$ = new Subject();

  public get evaluateConditions(): Subject<any> {
    return this._evaluateConditions$;
  }

  constructor(private lmFieldUtilService: LMFieldUtilService
    /*private _logger: LoggerService,
     private fieldUtil: FieldUtilService*/) {}

  public isValid(conditions: LMCondition[], data: LMDataView | LMModel): boolean {
    let isValid: boolean;
    if (!conditions) {
      isValid = true;
    } else if (!data) {
      isValid = false;
    } else {
      if (!Array.isArray(conditions)) {
        conditions = [ conditions ] as LMCondition[];
      }
      const len = conditions.length;
      let totalTrue = 0;
      for (const condition of conditions) {
        const args = this.createArgs(condition, data);
        totalTrue += this.isConditionValid(args) ? 1 : 0;
      }
      isValid = (len === 0) ? true : (totalTrue === len);
    }

    return isValid;
  }

  private createArgs(condition: LMCondition, data: LMDataView | LMModel): any {
    let fieldValue = null;
    const specType = null;
    if (condition.type === AppConstants.CONDITIONTYPE_DISPLAY) {
      if (condition.negated !== undefined) {
        fieldValue = condition.negated ? !condition.value : condition.value;
      } else {
        fieldValue = condition.value;
      }
    } else if (condition.type === AppConstants.CONDITIONTYPE_CONTEXT && data.contextProperties) {
        fieldValue = data.contextProperties[ condition.name ];
    } else if (condition.fieldId) {
      let field: LMField | LMModelField;
      const isModel: boolean = (data instanceof LMModel);
      // if (isModel) {
      //   let modelField = (data as LMModel).getField(condition.fieldId);
      //   fieldValue = modelField ? modelField.getData() : null;  // defensive code
      // } else {
      //   if ((data as LMDataView).fields.hasOwnProperty(condition.fieldId)) {
      //     fieldValue = (data as LMDataView).fields[ condition.fieldId ].value;
      //   }
      // }
      field = (isModel)
        ? (data as LMModel).getField(condition.fieldId) as LMField
        : (data as LMDataView).fields[condition.fieldId] as LMModelField;

      if (field) {
        fieldValue = field.value;
      } else {
        // nice to log this unexpected condition.
      }

      // DPB why was this changed?  talk to cheryl
      // field = (isModel)
      //   ? (data as LMModel).getField(condition.fieldId) as LMField
      //   : (data as LMDataView).fields[ condition.fieldId ] as LMModelField;
      // fieldValue = field.value;
    }
    // else fieldValue is undefined

    return { condition, fieldValue };
  }

  private isConditionValid(args) {
    const condition: LMCondition = args.condition;
    const fieldValue = args.fieldValue;

    let conditionValue;
    switch (condition.type) {
      case AppConstants.CONDITIONTYPE_ENTERED:
        conditionValue = !this.lmFieldUtilService.isBlank(condition.fieldType, fieldValue);
        break;
      case AppConstants.CONDITIONTYPE_FIELD:
        conditionValue = (/^(true|1|yes|y|on)$/i).test(fieldValue);
        break;
      case AppConstants.CONDITIONTYPE_VALUE:
        conditionValue = (/^(true|1|yes|y|on)$/i).test(condition.value.toString());
        break;
      case AppConstants.CONDITIONTYPE_STATE:
        // tslint:disable-next-line:triple-equals > List does not have spectype and sometimes a number is compared against a string.
        conditionValue = (fieldValue == condition.value);
        break;
      case AppConstants.CONDITIONTYPE_CONTEXT:
      case AppConstants.CONDITIONTYPE_DISPLAY:
        conditionValue = (/^(true|1|yes|y|on)$/i).test(fieldValue);
        break;
      default:
        conditionValue = true;
    }
    if (condition.negated !== undefined && condition.negated === true) {
      return !conditionValue;
    } else {
      return conditionValue;
    }
  }

  public isNavigationInvalid(layoutObject: LMButtonLayout, data: LMModel) {
    const navigation = layoutObject.navigation || layoutObject.linkNavigation;

    if (!data.navigations ||  data.navigations.length === 0) {
      return true;
    }

    return data.navigations.indexOf(navigation) === -1;
  }

  public displayAsTag(displayField: LMListDisplayField, dataView: LMDataView, fieldValue?: string): boolean {
    if (!displayField.displayAsTag || !fieldValue || fieldValue.trim().length === 0) {
      return false;
    }

    if (!displayField.tagStyle || displayField.tagStyle.length === 0) {
      return true;
    }

    // -------------------------------------------------------------
    // if all tag styles contain a condition and none are true
    // then don't display the tag.
    // -------------------------------------------------------------
    // if there is at least one tag style w/o a condition then displayAsTag is true
    if (displayField.tagStyle.filter(tagStyle => !tagStyle.condition).length > 0) {
      return true;
    }

    // if a condition is true then return the displayAsTag is true; else false
    return displayField.tagStyle.some(tagStyle => this.isValid([tagStyle.condition], dataView));
  }
}
